howspace.components.copyButton = (() => {
    'use strict';

    const handleClick = async function (e) {
        e.stopPropagation();

        const btn = $(this);

        if (btn.data('content')) {
            await navigator.clipboard.writeText(btn.data('content')).then(() => {
                real.notification.show(howspace.translate('common_copied_to_clipboard'), 'success');
            }, () => {
                real.notification.show('Failed to copy to clipboard', 'danger');
            });
            return;
        }

        const target = btn.data('target');
        if (!target) {
            return;
        }

        const element = $(target);
        if (element.length === 0) {
            return;
        }

        await real.copyToClipboard(element, () => {
            real.notification.show(howspace.translate('common_copied_to_clipboard'), 'success');
        }, () => {
            real.notification.show('Failed to copy to clipboard', 'danger');
        });
    }

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-copy-button:not(.howspace-copy-button-initialized)').each(function () {
                const copyButton = $(this);
                copyButton.addClass('howspace-copy-button-initialized');

                copyButton.on('click', handleClick);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-copy-button.howspace-copy-button-initialized').each(function () {
                const copyButton = $(this);
                copyButton.removeClass('howspace-copy-button-initialized');

                copyButton.off('click', handleClick);
            });
        }
    };
})();
